<template>
  <div class="wsdt">
    <img src="" alt="">
    <tops></tops>
    <div class="account-cancel-container">
      <!-- 页面标题 -->
      <div class="page-header">
        <h1>{{$t('zhuxiao.title')}}</h1>
        <p class="subtitle">{{$t('zhuxiao.yedu')}}</p>
      </div>

      <!-- 风险提示区域 -->
      <div class="risk-tips">
        <h3 class="tips-title">⚠️ {{$t('zhuxiao.fxTs')}}</h3>
        <ul class="tips-list">
          <li>{{$t('zhuxiao.ts1')}}</li>
          <li>{{$t('zhuxiao.ts2')}}</li>
          <li>{{$t('zhuxiao.ts3')}}</li>
          <li>{{$t('zhuxiao.ts4')}}</li>
        </ul>
      </div>

      <!-- 身份验证表单 -->
      <div class="auth-form" v-if="!cancelResult">
        <el-form
          ref="cancelForm"
          :model="formData"
          :rules="formRules"
          label-width="100px"
          class="form-content"
        >
          <!-- 称呼验证（原游戏账号） -->
          <el-form-item :label="$t('zhuxiao.chhu')" prop="nickname">
            <el-input
              v-model="formData.nickname"
              :placeholder="$t('zhuxiao.chhuTs')"
              :disabled="isLoading"
            />
          </el-form-item>

          <!-- ID验证（原登录密码） -->
          <el-form-item :label="$t('zhuxiao.zhID')" prop="id">
            <el-input
              v-model="formData.id"
              type="password"
              :placeholder="$t('zhuxiao.zhIDTs')"
              :disabled="isLoading"
            />
          </el-form-item>

          <!-- 新增：邮箱验证（选填） -->
          <el-form-item :label="$t('zhuxiao.email')" prop="email">
            <el-input
              v-model="formData.email"
              :placeholder="$t('zhuxiao.emailTs')"
              :disabled="isLoading"
              type="email"
            />
          </el-form-item>

          <!-- 错误提示 -->
          <el-form-item v-if="errorMsg">
            <div class="error-text">{{ errorMsg }}</div>
          </el-form-item>

          <!-- 确认注销按钮 -->
          <el-form-item>
            <el-button
              type="danger"
              size="large"
              @click="confirmCancel"
              :loading="isLoading"
              class="cancel-btn"
            >
                {{$t('zhuxiao.anNiu')}}
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 注销结果提示 -->
      <div class="result-container" v-if="cancelResult">
        <div class="result-icon" :class="{ success: cancelResult.success, fail: !cancelResult.success }">
          <i class="el-icon-success" v-if="cancelResult.success"></i>
          <i class="el-icon-error" v-else></i>
        </div>
        <div class="result-text">
          <h3>{{ $t('zhuxiao.tjcg') }}</h3>
          <p>{{ cancelResult.message }}</p>
        </div>
        <el-button type="primary" @click="resetPage" v-if="!cancelResult.success">{{$t('zhuxiao.fhTs')}}</el-button>
      </div>
    </div>
    <Foorm></Foorm>
    <!-- 二次确认弹窗 -->
    <el-dialog
      :title="$t('zhuxiao.quren')"
      :visible.sync="confirmDialog"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog-content">
        <p>{{$t('zhuxiao.zxtsEr')}}</p>
        <p class="dialog-warning">{{$t('zhuxiao.qurenTs')}}</p>
        <el-input
          v-model="confirmText"
          :placeholder="$t('zhuxiao.qrtx')"
          class="confirm-input"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="confirmDialog = false">{{$t('zhuxiao.quxiao')}}</el-button>
        <el-button
          type="danger"
          @click="submitCancelAccount"
          :loading="isLoading"
        >
            {{$t('zhuxiao.tjAn')}}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Foorm from '@/components/fooret.vue';
import tops from '@/components/top.vue';
export default {
  name: "GameAccountCancel",
  components: {
    Foorm,
    tops
  },
  data() {
    return {
      // 表单数据 - 调整字段名称并新增邮箱（移除手机号/验证码）
      formData: {
        nickname: "",    // 称呼（原游戏账号）
        id: "",          // ID（原登录密码）
        email: "",       // 邮箱（选填）
      },
      // 表单校验规则 - 调整规则并新增邮箱校验（选填）
      formRules: {
        nickname: [
          { required: true, message: this.$t('zhuxiao.ch_message'), trigger: "blur" },
          { min: 3, max: 30, message: this.$t('zhuxiao.Gui_ch'), trigger: "blur" },
        ],
        id: [
          { required: true, message: this.$t('zhuxiao.id_message'), trigger: "blur" },
          { min: 6, max: 20, message: this.$t('zhuxiao.Gui_id'), trigger: "blur" },
        ],
        email: [
          { 
            pattern: /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, 
            message: this.$t('zhuxiao.email_message'), 
            trigger: "blur",
            required: false // 选填
          },
        ],
      },
      isLoading: false, // 加载状态
      errorMsg: "", // 错误提示
      confirmDialog: false, // 二次确认弹窗
      confirmText: "", // 确认输入文本
      cancelResult: null, // 注销结果 { success: boolean, message: string }
    };
  },
  methods: {
    // 点击确认注销 - 校验称呼、ID、邮箱（邮箱选填）
    confirmCancel() {
      this.errorMsg = "";
      // 校验整个表单（包含称呼、ID、邮箱）
      this.$refs.cancelForm.validate((valid) => {
        if (!valid) return;

        // 表单校验通过，显示二次确认弹窗
        this.confirmDialog = true;
        this.confirmText = ""; // 重置确认文本
      });
    },

    // 提交注销账号请求
    submitCancelAccount() {
      // 校验确认文本
      if (this.confirmText !== "确认注销" && this.confirmText !== "Confirm Cancellation") {
        this.$message.error(this.$t('zhuxiao.confirm_message'));
        return;
      }

      this.isLoading = true;
      // 模拟注销接口请求（实际项目中替换为真实接口，可传递nickname/id/email等参数）
      
        this.isLoading = false;
        this.confirmDialog = false;
      
    },

    // 重置页面状态（失败后返回重新操作）
    resetPage() {
      this.cancelResult = null;
      this.formData = {
        nickname: "",
        id: "",
        email: "",
      };
      this.errorMsg = "";
    },
  },
};
</script>

<style>
/* 主容器 - 整体居中核心样式 */
.wsdt {
    height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-image: url('../assets/qingxi_tu.png');
  background-size: cover;
  background-position: center;
}
.bj_img {
  width: 100%;
    position: absolute;
    top: -80px;
    z-index:1;
}
/* 自定义了 */
.el-dialog{
    width: 100%;
    border-radius: 8px;
}
.el-form-item__label{
    width: 55px !important;
}
.el-form-item__content{
    margin-left: 55px !important;
}
.account-cancel-container {
  width: 600px;
  padding-top: 110px;
  padding-bottom: 50px;
  position: relative;
  z-index: 10;
}

/* 顶部标题区域 */
.page-header {
  text-align: center;
  margin-bottom: 30px;
}

.page-header h1 {
  color: #f2f2f2;
  font-size: 30px;
  margin-bottom: 10px;
}

.page-header .subtitle {
  color: #d4d4d4;
  font-size: 14px;
}

/* 风险提示区域 - 居中显示 */
.risk-tips {
  background: #fff8f8;
  border: 1px solid #ffccc7;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
  width: 100%;      /* 继承容器宽度 */
  box-sizing: border-box;
}

.tips-title {
  color: #f56c6c;
  font-size: 16px;
  margin-bottom: 10px;
  text-align: center; /* 提示标题居中 */
}

.tips-list {
  color: #666;
  font-size: 14px;
  line-height: 1.8;
  padding-left: 20px;
  margin: 0 auto;     /* 列表本身居中 */
  max-width: 700px;   /* 列表内容限制宽度，避免太宽 */
}

/* 表单区域 - 居中显示 */
.auth-form {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;     /* 表单容器居中 */
}

/* 表单内容居中适配 */
.form-content {
  max-width: 600px;   /* 表单内部限制宽度 */
  margin: 0 auto;     /* 表单内容居中 */
}

.error-text {
  color: #f56c6c;
  font-size: 13px;
  margin-top: 5px;
  text-align: center; /* 错误提示居中 */
}

.cancel-btn {
  width: 100%;
  margin: 0 auto;     /* 按钮居中 */
  display: block;     /* 块级显示才能margin auto */
}

/* 弹窗样式 */
.dialog-content {
  padding: 10px 0;
  text-align: center; /* 弹窗内容居中 */
}

.dialog-warning {
  color: #f56c6c;
  margin-top: 10px;
}

.confirm-input {
  margin-top: 20px;
  max-width: 300px;   /* 确认输入框限制宽度 */
  margin-left: auto;
  margin-right: auto;
  display: block;
}

/* 结果提示区域 - 居中显示 */
.result-container {
  text-align: center;
  padding: 50px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;
}

.result-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.result-icon.success {
  color: #67c23a;
}

.result-icon.fail {
  color: #f56c6c;
}

.result-text h3 {
  color: #333;
  font-size: 18px;
  margin-bottom: 10px;
}

.result-text p {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;     /* 结果文本居中 */
}

/* 适配小屏幕 */
@media (max-width: 768px) {
  .account-cancel-container {
    width: 100%;
    margin: 30px auto;
    padding: 0 15px;
    padding-top: 80px;
  }

  .tips-list {
    padding-left: 15px;
  }

  .form-content {
    max-width: 100%;
  }

  .cancel-btn {
    max-width: 100%;
  }
}
</style>